const TYPES = {
  LOAD_START: 'LOAD_START',
  LOAD_END: 'LOAD_END',
};

export default TYPES;
